module.exports = __webpack_public_path__ + "img/limpieza.fec99e4b.svg";